import React from 'react';
import './SubTabsSelect.css';

/**
 * Phone-only (<=767px) dropdown replacement for a horizontal sub-tab strip.
 * Render it next to the strip and add `rt-subtabs-strip` to the strip so it hides on phones.
 *
 * tabs: [{ id, label }]
 */
export default function SubTabsSelect({ tabs, value, onChange, ariaLabel = 'Section', className = '' }) {
  if (!Array.isArray(tabs) || tabs.length < 2) return null;
  return (
    <select
      className={`rt-subtabs-select${className ? ` ${className}` : ''}`}
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value)}
      aria-label={ariaLabel}
    >
      {tabs.map((tab) => (
        <option key={tab.id} value={tab.id}>
          {tab.label}
        </option>
      ))}
    </select>
  );
}
